import { forwardRef, type Ref, type SVGProps } from "react";
const IconParkingFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16.94 11H15v5h1.51c1.81 0 2.93-.68 2.93-2.5a2.29 2.29 0 0 0-2.5-2.5" />
    <path d="M28 2H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M17.52 19H15v5h-4V8h6.56A5.18 5.18 0 0 1 23 13.53 5.13 5.13 0 0 1 17.52 19" />
  </svg>
);
const ForwardRef = forwardRef(IconParkingFilledSVG);
ForwardRef.displayName = "IconParkingFilled";
export { ForwardRef as IconParkingFilled };
